module.exports = [{
      plugin: require('/Users/lukepurton/dev/ella/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-139216179-1"},
    },{
      plugin: require('/Users/lukepurton/dev/ella/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
